export default __webpack_public_path__ + "media/images/tenant/timeline/step_3-51e796fa5ba804614b6cffe1d2b0f7d4.webp";